/**
 * @generated SignedSource<<0c4ee20c0385dc023858fe00e9c3e230>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRecentSales_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"getAppliedFilterDisplayName_itemSearch">;
  readonly " $fragmentType": "SbRespRecentSales_itemSearch";
};
export type SbRespRecentSales_itemSearch$key = {
  readonly " $data"?: SbRespRecentSales_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRecentSales_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRecentSales_itemSearch",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getAppliedFilterDisplayName_itemSearch",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "kind": "LinkedField",
          "name": "appliedFilters",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "kind": "LinkedField",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "8ec13aad9e96e0d46836b167cf475695";

export default node;
